export default {
  metaTitleTemplate: {
    id: 'home_meta_title_template',
    defaultMessage: '%s | Back Market',
  },
}
